import { ZoomIn as ZoomInIcon } from '@material-ui/icons';
import { t } from '@lingui/macro';

import { Action } from './Actions';
import { useCanZoomIn } from '../../../stores/TimeRangeHistoryStore';
import { useTimeRangeNavigation } from '../../../utilities/TimeRangeNavigationUtilities';

export default function ZoomInAction(props) {
    const [canZoomIn] = useCanZoomIn();
    const { enabled, zoomIn } = useTimeRangeNavigation();

    return enabled ? (
        <Action
            icon={<ZoomInIcon />}
            tooltip={t`Zoom the time range in`}
            disabled={!canZoomIn}
            onClick={zoomIn}
            {...props}
        />
    ) : null;
}
